import script from "./AddMortgagePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddMortgagePage.vue?vue&type=script&setup=true&lang=ts"

import "./AddMortgagePage.vue?vue&type=style&index=0&id=096df944&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-096df944"]])

export default __exports__